import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from "styled-components";
import tw from "twin.macro";
import { NavBar } from "../../components/NavBar";
import BackgroundImage from "../../images-optimized/kumosecretcornerbg.webp";

const LandingSection = styled.div`
  ${tw`
        w-full
        overflow-scroll
        flex
        flex-col
        min-h-screen
    `};
  background-image: url(${BackgroundImage});
  background-size: cover;
  background-blend-mode: overlay;
`;

export function KumosSecretCorner() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const correctPassword = 'secret123'; // Replace with actual logic

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === correctPassword) {
      setError('');
      navigate('/storytime');
    } else {
      setError(
        "The special code entered is incorrect. If you do not have a code, feel free to join my Patreon page at " +
        "https://www.patreon.com/kumoxworld and once you join you will receive a unique code that allows you access to Kumo's Secret Corner."
      );
    }
  };

  return (
    <LandingSection>
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: '2rem' }}>
      <form onSubmit={handleSubmit} style={{ width: '100%', maxWidth: '400px' }}>
        <input
          type="password"
          placeholder="Enter the secret code"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ width: '100%', padding: '0.75rem', marginBottom: '1rem', borderRadius: '0.5rem', border: '1px solid #ccc' }}
        />
        <button type="submit" style={{ width: '100%', padding: '0.75rem', borderRadius: '0.5rem', backgroundColor: '#3d3d3d', color: '#fff', border: 'none' }}>
          Enter Kumo's Secret Corner
        </button>
        {error && <p style={{ color: 'red', fontSize: '0.875rem', marginTop: '1rem', whiteSpace: 'pre-line' }}>{error}</p>}
      </form>
    </div>
    </LandingSection>
  );
}
